/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyInvoiceErrorCodes = exports.ValueTypeEnum = exports.SubdivisionType = exports.StructNullValue = exports.SourceType = exports.QuotesSortOrder = exports.PriceQuoteStatus = exports.Placement = exports.PaymentTermType = exports.InvoicesSortableField = exports.InvoiceStatus = exports.IdlSortableField = exports.ErrorResult = exports.DisplayStatus = exports.CustomFieldGroup = exports.CommonSortOrder = void 0;
var CommonSortOrder;
(function (CommonSortOrder) {
    CommonSortOrder["ASC"] = "ASC";
    CommonSortOrder["DESC"] = "DESC";
})(CommonSortOrder = exports.CommonSortOrder || (exports.CommonSortOrder = {}));
var CustomFieldGroup;
(function (CustomFieldGroup) {
    CustomFieldGroup["FOOTER"] = "FOOTER";
    CustomFieldGroup["UNKNOWN_CUSTOM_FIELD_GROUP"] = "UNKNOWN_CUSTOM_FIELD_GROUP";
    CustomFieldGroup["DOCUMENT"] = "DOCUMENT";
    CustomFieldGroup["OTHER"] = "OTHER";
    CustomFieldGroup["BUSINESS_DETAILS"] = "BUSINESS_DETAILS";
    CustomFieldGroup["CUSTOMER_DETAILS"] = "CUSTOMER_DETAILS";
})(CustomFieldGroup = exports.CustomFieldGroup || (exports.CustomFieldGroup = {}));
var DisplayStatus;
(function (DisplayStatus) {
    DisplayStatus["Draft"] = "Draft";
    DisplayStatus["Sent"] = "Sent";
    DisplayStatus["Processing"] = "Processing";
    DisplayStatus["Paid"] = "Paid";
    DisplayStatus["Overdue"] = "Overdue";
    DisplayStatus["Void"] = "Void";
    DisplayStatus["Deleted"] = "Deleted";
    DisplayStatus["PartiallyPaid"] = "PartiallyPaid";
    DisplayStatus["PartialAndOverdue"] = "PartialAndOverdue";
})(DisplayStatus = exports.DisplayStatus || (exports.DisplayStatus = {}));
var ErrorResult;
(function (ErrorResult) {
    ErrorResult["DuplicateInvoiceNumber"] = "DuplicateInvoiceNumber";
    ErrorResult["InvalidTpaInstance"] = "InvalidTpaInstance";
    ErrorResult["EntityNotFound"] = "EntityNotFound";
    ErrorResult["UnknownTimeRange"] = "UnknownTimeRange";
    ErrorResult["TokenValidationError"] = "TokenValidationError";
    ErrorResult["DuplicateAggregate"] = "DuplicateAggregate";
    ErrorResult["NoError"] = "NoError";
    ErrorResult["ConcurrentUpdate"] = "ConcurrentUpdate";
    ErrorResult["IllegalParameter"] = "IllegalParameter";
    ErrorResult["NotSupported"] = "NotSupported";
    ErrorResult["AppProvisionError"] = "AppProvisionError";
})(ErrorResult = exports.ErrorResult || (exports.ErrorResult = {}));
var IdlSortableField;
(function (IdlSortableField) {
    IdlSortableField["IssueDate"] = "IssueDate";
    IdlSortableField["ByCustomer"] = "ByCustomer";
    IdlSortableField["Title"] = "Title";
    IdlSortableField["ValidThroughDate"] = "ValidThroughDate";
    IdlSortableField["QuoteNumber"] = "QuoteNumber";
    IdlSortableField["Total"] = "Total";
    IdlSortableField["Status"] = "Status";
    IdlSortableField["AcceptanceDate"] = "AcceptanceDate";
})(IdlSortableField = exports.IdlSortableField || (exports.IdlSortableField = {}));
var InvoiceStatus;
(function (InvoiceStatus) {
    InvoiceStatus["Paid"] = "Paid";
    InvoiceStatus["PartiallyPaid"] = "PartiallyPaid";
    InvoiceStatus["Deleted"] = "Deleted";
    InvoiceStatus["PartialAndOverdue"] = "PartialAndOverdue";
    InvoiceStatus["Processing"] = "Processing";
    InvoiceStatus["Sent"] = "Sent";
    InvoiceStatus["Overdue"] = "Overdue";
    InvoiceStatus["Void"] = "Void";
    InvoiceStatus["Draft"] = "Draft";
})(InvoiceStatus = exports.InvoiceStatus || (exports.InvoiceStatus = {}));
var InvoicesSortableField;
(function (InvoicesSortableField) {
    InvoicesSortableField["ByCustomer"] = "ByCustomer";
    InvoicesSortableField["QuoteNumber"] = "QuoteNumber";
    InvoicesSortableField["Total"] = "Total";
    InvoicesSortableField["Status"] = "Status";
    InvoicesSortableField["DueDate"] = "DueDate";
    InvoicesSortableField["IssueDate"] = "IssueDate";
})(InvoicesSortableField = exports.InvoicesSortableField || (exports.InvoicesSortableField = {}));
var PaymentTermType;
(function (PaymentTermType) {
    PaymentTermType["DueOnReceipt"] = "DueOnReceipt";
    PaymentTermType["Other"] = "Other";
    PaymentTermType["TimeStamp"] = "TimeStamp";
    PaymentTermType["NetPlus"] = "NetPlus";
})(PaymentTermType = exports.PaymentTermType || (exports.PaymentTermType = {}));
var Placement;
(function (Placement) {
    Placement["Unknown"] = "Unknown";
    Placement["After"] = "After";
    Placement["Replace"] = "Replace";
    Placement["Before"] = "Before";
})(Placement = exports.Placement || (exports.Placement = {}));
var PriceQuoteStatus;
(function (PriceQuoteStatus) {
    PriceQuoteStatus["Void"] = "Void";
    PriceQuoteStatus["Deleted"] = "Deleted";
    PriceQuoteStatus["Rejected"] = "Rejected";
    PriceQuoteStatus["Draft"] = "Draft";
    PriceQuoteStatus["Invoiced"] = "Invoiced";
    PriceQuoteStatus["Sent"] = "Sent";
    PriceQuoteStatus["Expired"] = "Expired";
    PriceQuoteStatus["Processing"] = "Processing";
    PriceQuoteStatus["Accepted"] = "Accepted";
})(PriceQuoteStatus = exports.PriceQuoteStatus || (exports.PriceQuoteStatus = {}));
var QuotesSortOrder;
(function (QuotesSortOrder) {
    QuotesSortOrder["Ascending"] = "Ascending";
    QuotesSortOrder["Descending"] = "Descending";
})(QuotesSortOrder = exports.QuotesSortOrder || (exports.QuotesSortOrder = {}));
var SourceType;
(function (SourceType) {
    SourceType["OTHER"] = "OTHER";
    SourceType["WIX_APP"] = "WIX_APP";
    SourceType["ADMIN"] = "ADMIN";
    SourceType["EXTERNAL"] = "EXTERNAL";
    SourceType["UNKNOWN_SOURCE_TYPE"] = "UNKNOWN_SOURCE_TYPE";
})(SourceType = exports.SourceType || (exports.SourceType = {}));
var StructNullValue;
(function (StructNullValue) {
    StructNullValue["NULL_VALUE"] = "NULL_VALUE";
})(StructNullValue = exports.StructNullValue || (exports.StructNullValue = {}));
var SubdivisionType;
(function (SubdivisionType) {
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_2"] = "ADMINISTRATIVE_AREA_LEVEL_2";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_4"] = "ADMINISTRATIVE_AREA_LEVEL_4";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_3"] = "ADMINISTRATIVE_AREA_LEVEL_3";
    SubdivisionType["UNKNOWN_SUBDIVISION_TYPE"] = "UNKNOWN_SUBDIVISION_TYPE";
    SubdivisionType["COUNTRY"] = "COUNTRY";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_1"] = "ADMINISTRATIVE_AREA_LEVEL_1";
    SubdivisionType["ADMINISTRATIVE_AREA_LEVEL_5"] = "ADMINISTRATIVE_AREA_LEVEL_5";
})(SubdivisionType = exports.SubdivisionType || (exports.SubdivisionType = {}));
var ValueTypeEnum;
(function (ValueTypeEnum) {
    ValueTypeEnum["BOOLEAN"] = "BOOLEAN";
    ValueTypeEnum["NUMBER"] = "NUMBER";
    ValueTypeEnum["DATE"] = "DATE";
    ValueTypeEnum["UNKNOWN_VALUE_TYPE"] = "UNKNOWN_VALUE_TYPE";
    ValueTypeEnum["STRING"] = "STRING";
})(ValueTypeEnum = exports.ValueTypeEnum || (exports.ValueTypeEnum = {}));
var VerifyInvoiceErrorCodes;
(function (VerifyInvoiceErrorCodes) {
    VerifyInvoiceErrorCodes["MISSING_INVOICE_CUSTOMER_CONTACT_ID"] = "MISSING_INVOICE_CUSTOMER_CONTACT_ID";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_BALANCE_IS_NEGATIVE"] = "INVALID_INVOICE_BALANCE_IS_NEGATIVE";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_LINE_ITEM_EMPTY_NAME"] = "INVALID_INVOICE_LINE_ITEM_EMPTY_NAME";
    VerifyInvoiceErrorCodes["FAILED_READING_BUSINESS_INFO"] = "FAILED_READING_BUSINESS_INFO";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_LINE_ITEM_TAX"] = "INVALID_INVOICE_LINE_ITEM_TAX";
    VerifyInvoiceErrorCodes["MISSING_INVOICE_CURRENCY"] = "MISSING_INVOICE_CURRENCY";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_TOTAL_TOO_LARGE"] = "INVALID_INVOICE_TOTAL_TOO_LARGE";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_ISSUE_DATE"] = "INVALID_INVOICE_ISSUE_DATE";
    VerifyInvoiceErrorCodes["UNKNOWN_VERIFICATION_ERROR"] = "UNKNOWN_VERIFICATION_ERROR";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_CURRENCY"] = "INVALID_INVOICE_CURRENCY";
    VerifyInvoiceErrorCodes["MISSING_INVOICE_CUSTOMER"] = "MISSING_INVOICE_CUSTOMER";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_FIELDS"] = "INVALID_INVOICE_FIELDS";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_CUSTOMER_EMAIL"] = "INVALID_INVOICE_CUSTOMER_EMAIL";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_DISCOUNT_RATE"] = "INVALID_INVOICE_DISCOUNT_RATE";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_DUE_DATE_BEFORE_ISSUE_DATE"] = "INVALID_INVOICE_DUE_DATE_BEFORE_ISSUE_DATE";
    VerifyInvoiceErrorCodes["INVALID_INVOICE_TOTAL_IS_NEGATIVE"] = "INVALID_INVOICE_TOTAL_IS_NEGATIVE";
    VerifyInvoiceErrorCodes["MISSING_INVOICE_LINE_ITEMS"] = "MISSING_INVOICE_LINE_ITEMS";
})(VerifyInvoiceErrorCodes = exports.VerifyInvoiceErrorCodes || (exports.VerifyInvoiceErrorCodes = {}));
//# sourceMappingURL=types.js.map